import React, { useState } from 'react';
import historyData from '../../data/history-data';

const filters = [
    { id: 1, name: 'Tüm Projeler', filterData: 'all' },
    { id: 2, name: 'Tamamlanan Projeler', filterData: 'completed' },
    { id: 3, name: 'Devam Eden Projeler', filterData: 'ongoing' }
];

const getFilteredProjects = (filterData) => {
    if (filterData === 'all') {
        return historyData.filter((project) => project);
    }

    if (filterData === 'completed') {
        return historyData.filter((project) => project.endDate !== 'Devam Ediyor' && project);
    }

    return historyData.filter((project) => project.endDate === 'Devam Ediyor' && project);
};

const CompanyHistory = () => {
    const [filter, setFilter] = useState('all');
    const filteredProjects = getFilteredProjects(filter);

    return (
        <div className="history__area section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 mb-80">
                        <div className="gallery__area-button t-center">
                            {filters.map(({ id, name, filterData }) => (
                                <button
                                    key={id}
                                    onClick={() => setFilter(filterData)}
                                    className={filter === filterData ? 'active' : ''}
                                >
                                    {name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="company__history-area">
                            {filteredProjects.map((item, id) => (
                                <div className="company__history-area-item" key={id}>
                                    <div className="company__history-area-item-date">
                                        <span className="alt-icon" style={{ fontSize: '18px', position: 'relative' }}>
                                            {item.endDate === 'Devam Ediyor' ? (
                                                <i
                                                    className="fa-regular fa-person-digging fa-fade"
                                                    aria-hidden="true"
                                                    style={{
                                                        fontSize: '36px',
                                                        lineHeight: 1,
                                                        position: 'absolute',
                                                        left: '55%',
                                                        top: '47%',
                                                        transform: 'translate(-50%, -50%)'
                                                    }}
                                                ></i>
                                            ) : (
                                                item.date
                                            )}
                                        </span>
                                    </div>
                                    <div className="company__history-area-item-inner">
                                        <div className="company__history-area-item-inner-content">
                                            <div className="text-center">
                                                <h4 className='mainTitle'>{item.title}</h4>
                                                <h4 className='subTitle'>{item.subtitle}</h4>
                                                <p className='subText'>Baslangıç Tarihi: {item.startDate} - Bitiş Tarihi: {item.endDate}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyHistory;